class ScienceCollapsible extends HTMLElement {
  constructor() {
    super();

    this.text_input = this.querySelector('[data-science-text]');
    this.heading_input = this.querySelector('[data-science-heading]');

    this.dots = this.querySelectorAll('.science-collapsible [data-dot]');
    this.dots_array = Array.from(this.dots);
    this.first_dot = this.dots[0].dataset.dot;
    this.replaceContent(this.first_dot)

    this.dots_array.forEach((dot) => {
      dot.addEventListener('click', this.onDotClick.bind(this));
    });

    this.createBars();
    this.setActiveBar();
    this.counter();
    this.updateImage();

    this.next_btn = document.querySelector('.circle_next')
    this.previous_btn = document.querySelector('.circle_previous')
    this.next_btn.addEventListener('click', () => this.navigationOnClick.bind(this)('next', 1))
    this.previous_btn.addEventListener('click', () => this.navigationOnClick.bind(this)('previous', this.dots_array.length))
  }
  
  replaceContent(item_position) {
    this.text_info = this.querySelector(`[data-text-info="${item_position}"]`);
    this.heading_info = this.querySelector(`[data-dot="${item_position}"]`);
    this.text_input.innerHTML = this.text_info.innerHTML;
    this.heading_input.innerHTML = this.heading_info.innerHTML;
    this.heading_info.classList.add('active_dot');
  }

  onDotClick(event) {
    event.preventDefault();
    const target_item = event.target.closest('.circle_dots').querySelector('[data-dot]');
    const attr = target_item.dataset.dot;
    this.replaceContent(attr)
    this.dots_array.forEach(item => {
      if(item !== target_item && item.classList.contains('active_dot')) {
        item.classList.remove('active_dot');
      }
    })
    this.setActiveBar();
    this.counter();
    this.updateImage();
  }

  navigationOnClick(clickType, resetPosition) {
    const current_active = this.querySelector('.active_dot');
    let next_active_position = current_active.closest('.circle_dots');
    if(clickType === "next") {
      next_active_position = next_active_position.nextSibling ? next_active_position.nextSibling.querySelector('[data-dot]').getAttribute('data-dot') : resetPosition;
    }
    if(clickType === "previous") {
      next_active_position = next_active_position.previousSibling ? next_active_position.previousSibling.querySelector('[data-dot]').getAttribute('data-dot') : resetPosition;
    }
    current_active.classList.remove('active_dot');
    this.replaceContent(next_active_position);
    this.setActiveBar();
    this.counter();
    this.updateImage()
  }

  createBars() {
    const bar_count = this.dots_array.length;
    const bar_container = this.querySelector('.ciricle_progress_bar');
    const node = document.createElement('span');
    node.classList.add('bar_node')

    for(let i = 0; i < bar_count; i++ ) {
      const clone = node.cloneNode(true);
      clone.setAttribute('data-bar', i+1)
      bar_container.appendChild(clone)
    }
  }

  setActiveBar() {
    const current_active = this.querySelector('.active_dot').dataset.dot;
    const bars = this.querySelectorAll('.ciricle_progress_bar .bar_node');
    const bars_array = Array.from(bars)
    bars_array.forEach(bar => { 
    bar.dataset.bar === current_active ? bar.classList.add('active_bar') : bar.classList.remove('active_bar');
    })
  }

  counter() {
    let counter_number = this.querySelector('.counter_number');
    const current_active = this.querySelector('.active_dot').dataset.dot;
    counter_number.innerHTML = current_active;
  }

  updateImage() {
    const img_container = this.querySelector('[data-circle-image]');
    const current_active = this.querySelector('.active_dot').dataset.dot;
    const image = this.querySelector(`[data-science-image="${current_active}"]`);
    const clone = image.cloneNode(true);
    img_container.innerHTML = "";
    img_container.append(clone);
  }
}


customElements.define("science-collapsible", ScienceCollapsible);
  
